module.exports = __webpack_public_path__ + "static/img/hn-face.fc2e433.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/case/hn-face.jpg
// module id = dWsV
// module chunks = 1